import React from 'react';
import { BO, Props } from 'components/Bo';
import { useDefaultCycle, useSetDefaultCycle } from './defaultCycleAtom';
import useBo from 'queries/bo/useBo';
import { Infobox } from 'components/Callout/Infobox';
import { Trans, useTranslation } from 'react-i18next';
import BoListComponent from 'components/Bo/BoListComponent';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from 'queries/user/useUpdateUser';
import useNotification from 'containers/App/Notifications/useNotification';
import useBos from 'queries/bo/useBos';

export function BoWithLocalFallbackCycle(
  props: Omit<
    Props,
    'boList' | 'boLabels' | 'onUpdateReferentiel' | 'guestMode' | 'bo'
  > & {
    boId: string;
  },
) {
  const defaultCycle = useDefaultCycle();
  const setDefaultCycle = useSetDefaultCycle();
  const updateUser = useUpdateUser();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);
  const { data, isLoading, isFetched, isError } = useBo(props.boId);
  const { data: boListData } = useBos();
  const userPref = useUser();

  const onUpdateReferentiel = (newRefId: string) =>
    updateUser({
      ...userPref,
      referencielId: newRefId,
    }).catch(() => notifyError({ title: t('common:messages.genericError') }));

  if (isError) {
    return (
      <Infobox tw="mb-8" intent="danger">
        <Trans i18nKey="referentiel:messages.fetchBoError">
          Le référentiel n&apos;a pas pu être récupéré 😢 <br />
          Essayez de sélectionner un autre référentiel :
        </Trans>
        <div tw="max-w-md mt-4">
          <BoListComponent
            boList={boListData || []}
            guestMode={userPref?.guestMode?.enabled}
            defaultReferentielId={userPref?.referencielId}
            onUpdateReferentiel={onUpdateReferentiel}
            minimal={false}
          />
        </div>
      </Infobox>
    );
  }
  if (!data || isLoading || !isFetched) {
    return <SpinnerComponent />;
  }

  return (
    <BO
      {...props}
      bo={data}
      boList={boListData || []}
      boLabels={userPref.boLabels}
      fallbackCycle={defaultCycle}
      onUpdateCycle={setDefaultCycle}
      guestMode={userPref?.guestMode?.enabled}
      onUpdateReferentiel={onUpdateReferentiel}
    />
  );
}
